// 保险产品ID
export const HaiNanLeChengInsuPlanId = 'ff808081718236c4017182426a440000'

// 客服链接
export const CustomerServiceLink = 'kefu.html'
export const CustomerServiceLink2 = 'https://077978.kefu.easemob.com/webim/im.html?configId=e56cdee2-6dfe-4e7f-9c51-57dffdc4c95f'

// 神策接口
export const register = 'https://portal.yuanxinbaoxian.com/data-channel-api/sd/dis/receiveSensorsData'

// 百度接口
export const bdBuriedUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? 'https://scrm.yuanxinbaoxian.com' : 'https://scrm-test.yuanxinbaoxian.com'

// 理赔报案链接
export const lipie = process.env.VUE_APP_BUILD_TARGET === 'prod' ? 'https://portal.yuanxinbaoxian.com/mobile-lz/#/' : 'http://test.yuanxinbaoxian.com/smcs-mobile-web-lz/customer/#/'

// 直播间链接
export const Livecustomerservice = 'http://wx.vzan.com/live/tvchat-1102574823?v=637698157679050880'

// 静态资源
export const cdnresources = 'https://static-cdn.yuanxinbaoxian.com'

// 倒计时结束时间
export const CountDownEndDate = '2021/05/10 23:59:59'

// 转盘抽奖
export const TurntableLottery = 'https://hd.faisco.cn/21994432/PjArAJG9tTVK_WXbPjDkpQ/load.html?style=55&editQrcode=true&_source=1'

// 出单中台接口判断
// export const outCenterUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? 'https://hmb.baoxian72.com' : 'https://hmb.baoxian72.com'
export const outCenterUrl = 'https://hmb.baoxian72.com'
